import { ContactSelectionLight } from '@/components/contact-selection/contact-selection.light';
import type { ContactType } from '@/components/contact-selection/props';
import { useGetPersonalInfo } from '@/hooks/api';
import { useSendCode } from '@/hooks/api/contact-validation.hooks';
import { useI18n } from '@nosinovacao/nosid-mfe-common';
import type { StepNavigation } from './models';

export function SettingsContactSelectionSection({ goToStep }: Readonly<StepNavigation>) {
  const { t } = useI18n();
  const { sendCodeAsync, isSending, captcha } = useSendCode();
  const { data: personalInfo } = useGetPersonalInfo();

  const phoneAlias = personalInfo?.UsernameAliases?.find((a) => a.Type === 'Mobile')?.Username;
  const emailAlias = personalInfo?.UsernameAliases?.find((a) => a.Type === 'Email')?.Username;

  const handleContactSelected = async (contactType: ContactType, targetId: string) => {
    if (captcha.challenge && !captcha.token) return;
    await sendCodeAsync({ targetId, type: contactType, captcha });
    const descriptionKey =
      contactType === 'Sms'
        ? 'Common.ContactValidation.CodeInput.Description.Phone'
        : 'Common.ContactValidation.CodeInput.Description.Email';
    goToStep('code-input', {
      contactType,
      targetId,
      subtitle: t(descriptionKey, { contact: targetId }),
    });
  };

  return (
    <ContactSelectionLight
      translations={{
        phone: 'Common.ContactValidation.ContactSelection.Phone',
        email: 'Common.ContactValidation.ContactSelection.Email',
      }}
      phoneAlias={phoneAlias}
      emailAlias={emailAlias}
      onContactSelected={(ct, tid) => void handleContactSelected(ct, tid)}
      isSending={isSending}
      captchaChallenge={captcha.challenge}
      onCaptchaChange={captcha.setToken}
    />
  );
}
